<template>
  <div>
    <div class="head ">
        <div class="wrap clearfix">
            <h1 class="fl logo"></h1>
            <h2 class="fl nav">
                <a href="#" class="active">购买U点</a>
            </h2>
            <input type="hidden" value="" id="cookie" class="fl" style="border:2px solid red;width:60px;color:red;font-size:20px;height:40px;">
            <!-- <b class="load fr">APP下载</b> -->

            <!-- <?php if($user_id>0){?> -->
                <p class="loginCss fr exit">退出</p>
            <!-- <?php }else{?>
                <p class="loginCss login fr" id="loginCookie">登录</p>
            <?php } ?> -->
            <!-- <div class="scanFb" >
                <img src="<?= Yii::$app->request->hostInfo?>/userinfo/images/arrowUp.png" style="width:13px;margin-left: 75px;_margin-left:0;">
                <div>
                    <img src="<?= Yii::$app->request->hostInfo?>/userinfo/images/scanFb.png">
                    <p>扫一扫下载疯播</p>
                </div>
            </div> -->
        </div>
    </div>
    <div class="con">
			<form   action="http://pay.live.sinashow.com/ucenter/upointpay.html" target="_self" id="payForm" method="post"  >
            <input type="hidden"  name="cp_id" value="167">    <!--cp_id      产品ID:   167 -->
            <input type="hidden"  name="wxpay_type" value="3">
            <input type="hidden"  name="client" value="pc">   <!--client     客户端类型:   pc -->
            <input type="hidden" id="user_id" name="user_id" value="">   <!--user_id    用户ID -->
            <input type="hidden" id="hall_id" name="hall_id" value="">  <!--hall_id    房间ID :默认0 -->
            <input type="hidden" id="re_uid" name="re_uid" value="0">      <!--re_uid     推荐人 :默认0          -->
            <input type="hidden" id="paytype" name="paytype" value="">   <!--paytype    支付方式: ips网银   wechat微信  zfb  支付宝 -->
            <input type="hidden" id="point" name="point" value="">       <!--point      金额:以元为单位 -->
            <input type="hidden" id="u" name="u" value="" >              <!--u          U点数量:  计算方式为point*2 -->
            <table>
                <tr>
                    <th>当前充值账号：</th>
                    <td v-if="userId" class="clearfix">
                        <b class="fl name">{{ userName }}</b>
                        <span class="fl red">( </span>
                        <b class="fl id">{{ userId }}</b>
                        <span class="fl red"> )</span>
                        <span class="fr u">您的U点：{{ point }}</span>
                    </td>
                </tr>
                <tr>
                    <th>推荐人ID：</th>
                    <td >
                        <p class="clearfix"><input type="text" placeholder="可不填" class="referee bgMini placeholder fl"></p>
                    </td>
                </tr>
                <tr>
                    <th>
                        <p>充值数量：</p>
                    </th>
                    <td>
                        <ul class="clearfix chargeAmount">
                            <li :class="pointCheck[20] ? 'checked' : ''" @click="CheckPoint(20, 10)">
                                <h4><span>20</span>万U点</h4>
                                <p>￥<span class="money">10</span></p>
                            </li>
                            <li :class="pointCheck[200] ? 'checked' : ''" @click="CheckPoint(200, 100)">
                                <h4><span>200</span>万U点</h4>
                                <p>￥<span class="money">100</span></p>
                            </li>
                            <li :class="pointCheck[1000] ? 'checked' : ''" @click="CheckPoint(1000, 500)">
                                <h4><span>1000</span>万U点</h4>
                                <p>￥<span class="money">500</span></p>
                            </li>
                            <li :class="pointCheck[2000] ? 'checked' : ''" @click="CheckPoint(2000, 1000)">
                                <h4><span>2000</span>万U点</h4>
                                <p>￥<span class="money">1000</span></p>
                            </li>
                            <li :class="pointCheck[6000] ? 'checked' : ''" @click="CheckPoint(6000, 3000)">
                                <h4><span>6000</span>万U点</h4>
                                <p>￥<span class="money">3000</span></p>
                            </li>
                            <li :class="'customBtn' + (pointCheck[0] ? ' checked' : '')" @click="CheckPoint(0, 10)">
                                <h4>自定义<br/>充值U点数</h4>
                            </li>
                        </ul>
                    </td>
                </tr>
                <tr v-if="pointCheck[0]" class="custom">
                    <th>请输入充值U点数：</th>
                    <td>
                        <div class="clearfix">
                            <input v-model="moneyNum" type="text" class="charge fl" onpaste="return false" maxlength="6" @focus="inputCheck" @keyup="keyInput">
                            <p class="errorPre fl" style="line-height:32px">&nbsp;&nbsp;万<b class=" red " style="margin-left:20px;">（最低充值20万U点）</b></p>
                        </div>
                    </td>
                </tr>
                <tr v-if="error" class="nullErr">
                    <th></th>
                    <td class="red">请填写正确的U点数！</td>
                </tr>
                <tr>
                    <th>应付金额：</th>
                    <td><b class="red payment">{{ money }}</b>元</td>
                </tr>
                <tr>
                    <th>支付平台：</th>
                    <td>
                        <ul class="clearfix platform">
                            <li :class="payType.zfb ? 'checked' : ''" paytype="zfb" maxMoney="10000"  maxU="20000" @click="payTypeCheck('zfb')">
                                <a href="#"><img src="@/assets/images/zfb.png" alt="">支付宝</a>
                            </li>
                            <li :class="payType.wechat ? 'checked' : ''" paytype="heepay" maxMoney="3000" maxU="6000" @click="payTypeCheck('wechat')">
                                <a href="#"><img src="@/assets/images/wechat.png" alt="">微信支付</a>
                            </li>
                       </ul>
                    </td>
                </tr>
                <tr>
                    <th></th>
                    <td>
                        <input type="button" class="submit comInp" value="确定" @click="paySubmit">
                    </td>
                </tr>
            </table>
        </form>
    </div>
  </div>
</template>

<script>
import '@/style/common.css'
import '@/style/home.css'
import jsonpAdapter from 'axios-jsonp';
export default {
  name: 'Pay',
  data() {
    return {
      userId: '',
      userName: '',
      point: 0,
      pointCheck: {
        20: false,
        200: false,
        1000: false,
        2000: false,
        6000: true,
        0: false
      },
      money: 3000,
      moneyNum: 20,
      error: false,
      payType: {
        zfb: true,
        wechat: false
      },
      type: 'zfb'
    }
  },
  computed: {
    userInfo(){
      if(this.$store.state.loginUserInfo.info){        
        let info = this.$store.state.loginUserInfo.info
        // console.log(info.user_id);
        if (Number(info.user_id) >= 900000000) {
          this.userId = '';
          this.userName = '';
        } else {
          this.userId = info.user_id
          this.userName = decodeURIComponent(info.nick_nm) 
        }        
        return this.$store.state.loginUserInfo.info;
      }else if(sessionStorage.getItem('userInfo')){
        let info = JSON.parse(sessionStorage.getItem('userInfo'))
        if (Number(info.user_id) >= 900000000) {
          this.userId = '';
          this.userName = '';
        } else {
          this.userId = info.user_id
          this.userName = decodeURIComponent(info.nick_nm) 
        }
        return JSON.parse(sessionStorage.getItem('userInfo'));
      }else{
        this.userId = '';
        this.userName = '';
        return {
            nick_nm:'游客912067379',
            user_id:'912067379'
        }
      }
    }
  },
  watch: {
    userInfo () {
      if (this.userInfo.user_id >= 900000000) {
        this.userId = '';
        this.userName = '';
      } else {
        this.userId = this.userInfo.user_id
        this.userName = decodeURIComponent(this.userInfo.nick_nm)
      }
      
    }
  },
  created() {
    document.title = '随风直播充值'
    if(this.userInfo.user_id > 900000000) {
      this.userId = '';
      this.userName = '';
      this.$store.commit('LOGINREGBOX_SHOW_HIDE_CLOSE',false);
	    this.$store.dispatch('upDataLoginRegShowBool',1);
    } else {
      this.userId = this.userInfo.user_id
      this.userName = decodeURIComponent(this.userInfo.nick_nm)
      this.getU()
    }
  },
  methods: {
    getU () {
      var uData={
        user_id:this.userInfo.user_id,
        logintype:localStorage.getItem('loginType'),
        reg_mac:localStorage.getItem('mac'),
        token:this.$store.state.loginUserInfo.token
      }
      this.axios({
        url:location.protocol+'//api.fengbolive.com/userinfo/getuserinfo/virtual.html?'+this.$common.changeobj(uData),
        adapter: jsonpAdapter
      }).then(res=>{
        res=res.data;
        this.point=res.data;
      })
    },
    CheckPoint(num, money) {
      this.pointCheck = {
        20: false,
        200: false,
        1000: false,
        2000: false,
        6000: false,
        0: false
      }
      this.pointCheck[num] = true
      this.money = money
    },
    inputCheck() {
      this.moneyNum = ''
      this.money = 0
      this.error = false
    },
    keyInput () {
      this.money = this.moneyNum / 2
    },
    payTypeCheck(type) {
      this.payType = {
        zfb: false,
        wechat: false
      }
      this.payType[type] = true
      this.type = type
    },
    paySubmit () {
      if((this.pointCheck[0] && this.money <= 0) || this.money % 2 != 0) {
        this.error = true
      }
      let params = {
        type: this.type,
        money: this.money
      }
      this.$store.dispatch('getPayInfo', params);
      this.$router.push({path: '/paysucc'})
    }
  }
}
</script>
